export default {"src":"/_next/static/media/notifications.90fd0304.svg","height":56,"width":47};